'use client';

import parkingSpotContractFilters from '@/app/dashboard/contracts/parking-spot/filters';
import { StatusBadge } from '@/components/ui/statusBadge';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  ParkingSpotContractConfig,
  type ParkingSpotContract,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const ParkingSpotContractItem: RelationFieldProps<ParkingSpotContract> =
  {
    nested: getRelationFieldNames(ParkingSpotContractConfig),
    filters: parkingSpotContractFilters,
    renderItem: (item, isRelationField) => ({
      title: item?.idNumber,
      badge:
        item.status != null ? (
          <StatusBadge
            className='font-medium'
            status={item.status}
            type='contract'
          />
        ) : undefined,
      descriptionItems: (
        <div
          className={cn(
            isRelationField ? 'grid w-full' : 'flex flex-row items-center'
          )}
        >
          <div className='font-medium'>
            {item.tenant?.communicationName ?? 'Ingen hyresgäst kopplad'}
          </div>
          {!isRelationField && <Dot />}
          <span> {item.customId ?? 'Inget objekts-id angivet'}</span>
        </div>
      ),
    }),
  };
